
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
export default function NotificationDeleteOne({cancelModal,id,removeObject}) {
    const { user } = useAuthContext();

//styled
    const handleDelete = () => {
        try {
          axios.delete(`${ApiConnectionString}/api/notification/${id}`, {
            headers: { Authorization: `bearer ${user.token}` },
          });
          removeObject(id)
        } catch (error) {
          console.error("Error deleting notification:", error);
          // Handle error
        } finally {
          cancelModal();
        }
      };

      
  return (
    <div className="send-modal-overlay">   
      <div className="send-modal">
    
      <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Notifcation</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
           <p>Are you sure you want to delete this notification?</p>

          <div className="send-modal-footer">
            <button className="delete-button mx-3" onClick={handleDelete}>Delete</button>
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
          </div>
      
      </div>
    </div>
  );
}
